<app-tree-table
  [(selection)]="selection"
  (focusDateChange)="focusDateChange($event)"
  (selectionChange)="selectionChange($event)"
  [actionColumnWidth]="150"
  [columns]="columns"
  [firstColumnFrozen]="true"
  [focusDate]="focusDate"
  [hasFocusDate]="true"
  [loading]="loading"
  [selectable]="true"
  [value]="value">
  <ng-template
    (onClick)="hierarchyMenu.show($event)"
    [labelKey]="'PERSONNEL_CATEGORY.FOCUS'"
    appToolbarButton
    icon="fal fa-folder-tree"></ng-template>

  <ng-template
    (onClick)="showDialog($event.row)"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>

  @if (isManager()) {
    <ng-template
      (onClick)="showDeactivate()"
      [disabled]="!deactivateEnabled"
      appToolbarButton
      icon="fal fa-stop-circle"
      labelKey="PERSONNEL_CATEGORY.DEACTIVATE_SELECTED"></ng-template>
  }

  @if (isManager()) {
    <ng-template
      (onClick)="showActivate()"
      [disabled]="!activateEnabled"
      appToolbarButton
      icon="fal fa-play-circle"
      labelKey="PERSONNEL_CATEGORY.ACTIVATE_SELECTED"></ng-template>
  }
</app-tree-table>

<p-tieredMenu
  (click)="hierarchyMenu.hide()"
  [hideTransitionOptions]="'0ms'"
  [model]="hierarchyMenuModel"
  [popup]="true"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '300px' }"
  #hierarchyMenu></p-tieredMenu>

<p-dialog
  [(visible)]="displayActivateDialog"
  [header]="'PERSONNEL_CATEGORY.ACTIVATE_SELECTED' | translate"
  [modal]="true"
  [style]="{ width: '700px' }">
  @if (form) {
    <form (ngSubmit)="saveActivate()" [formGroup]="form" novalidate>
      <div class="grid grid-cols-12">
        <app-form-switch
          [form]="form"
          [twoColumns]="false"
          id="inOfficialStaffingPlan"
          label="PERSONNEL_CATEGORY.IN_OFFICIAL_STAFFING_PLAN"></app-form-switch>
        <app-form-number-input
          [form]="form"
          [max]="100"
          [maxFractionDigits]="2"
          [min]="0"
          [minFractionDigits]="2"
          [twoColumns]="false"
          id="weightingStaffingPlan"
          label="PERSONNEL_CATEGORY.WEIGHTING_STAFFING_PLAN"
          suffix="%"></app-form-number-input>
        <app-form-date-input
          [form]="form"
          [timeOnly]="true"
          [twoColumns]="false"
          id="targetDailyValue"
          label="PERSONNEL_CATEGORY.TARGET_DAILY_VALUE"></app-form-date-input>
        <app-form-date-input
          [form]="form"
          [twoColumns]="false"
          id="validFrom"
          label="GLOBAL.GUELTIG_AB"></app-form-date-input>
        <div class="col-span-12">
          <p-button
            [disabled]="!form.valid"
            [label]="'ACTIONS.SAVE' | translate"
            [style]="{ 'margin-right': '0.5rem' }"
            icon="fal fa-save"
            type="submit"></p-button>
          <p-button
            (onClick)="displayActivateDialog = false"
            [label]="'ACTIONS.CANCEL' | translate"
            icon="fal fa-times"
            styleClass="ui-button-secondary"
            type="button"></p-button>
        </div>
      </div>
    </form>
  }
</p-dialog>
